import Lottie from "lottie-react";
import LottieIcon from "./CopyAnimation.json";
import { useRef } from "react";

const CopyAnimationComponent = ({ onClick, link, title, className }) => {
  const lottieRef = useRef(null);

  const handleClick = () => {
    onClick(link);
    if (lottieRef.current) {
      lottieRef.current.goToAndPlay(0, true);
    }
  };

  return (
    <div
      onClick={handleClick}
      className="tw-cursor-pointer tw-flex tw-items-center md:tw-justify-start tw-justify-center"
    >
      <p>{title}</p>
      <Lottie
        lottieRef={lottieRef}
        animationData={LottieIcon}
        loop={false}
        autoplay={false}
        className={`tw-w-10 ${className ?? ""} `}
      />
    </div>
  );
};

export default CopyAnimationComponent;
